import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { DepField, makeFiltersBuilder } from "@/features/FilterTable/utils";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

export const filterAdminUserActionSchema = z.object({
  action_button_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  page_from_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterAdminUserActionSchema = z.infer<
  typeof filterAdminUserActionSchema
>;

const adminActionDepFields: readonly DepField<FilterAdminUserActionSchema>[] = [
  {
    name: "action_button_contains",
    key: "action_button",
    extract: "text",
    bucket: "equals",
  },
  {
    name: "page_from_contains",
    key: "page_from",
    extract: "text",
    bucket: "equals",
  },
];

export const fields: Field[] = [
  {
    name: "action_button_contains",
    label: "Action Name",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/admin_user_actions",
    column_name: "action_button",
    filters: makeFiltersBuilder<FilterAdminUserActionSchema>(
      adminActionDepFields,
      "action_button_contains",
    ),
  },
  {
    name: "page_from_contains",
    label: "Action Page",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/admin_user_actions",
    column_name: "page_from",
    filters: makeFiltersBuilder<FilterAdminUserActionSchema>(
      adminActionDepFields,
      "page_from_contains",
    ),
  },
  {
    name: "date_from",
    label: "Action Date From",
    type: "date",
  },
  {
    name: "date_to",
    label: "Action Date To",
    type: "date",
  },
];

export const client = "qtl - etl";
export const tableName = "admin_user_actions";

export function FilterAdminUserAction() {
  return (
    <FilterTable
      client={client}
      schema={filterAdminUserActionSchema}
      tableName={tableName}
      customBuildPath={() => `${client}/admin_user_actions`}
      fields={fields}
    />
  );
}
